import { jsx as _jsx } from "react/jsx-runtime";
import { normalizeBlockTree } from './normalizeBlockTree.js';
import { renderBlockTree } from './layout/renderBlockTree.js';
export function BlockRenderer({ layout, className = 'space-y-6', ...options }) {
    const safeLayout = normalizeBlockTree(layout);
    return _jsx("div", { className: className, children: safeLayout.map((block) => renderBlockTree(block, options)) });
}
export default BlockRenderer;
